import React from "react"
import PropTypes from "prop-types"
import { Checkbox } from "@bitcine/cs-theme"
import AvailabilityAndExpiryDates from "../components/preview/send/shared/availability_and_expiry_dates"
class ExpiryDateTimePicker extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      available_at: props.sharedScreener.available_at,
      expiry: props.sharedScreener.expiry,
      notifyReviewers: props.sharedScreener.share_type === "email"
    }
  }
  save() {
    this.setState({ pending: true })
    this.props.onSave(this.state.available_at, this.state.expiry, this.state.notifyReviewers)
  }
  render() {
    return (
      <div className="center">
        <AvailabilityAndExpiryDates
          model={this.state}
          updateModel={(key, value) => this.setState({ [key]: value })}/>
        {this.props.sharedScreener.share_type === "email" && <div className="mt2">
          <Checkbox
            className='mt2'
            label='Notify reviewer of changes'
            checked={this.state.notifyReviewers}
            onChange={() => this.setState({ notifyReviewers: !this.state.notifyReviewers })}/>
        </div>}
        <button
          onClick={() => this.save()}
          disabled={(this.props.sharedScreener.available_at === this.state.available_at && this.props.sharedScreener.expiry === this.state.expiry) || this.state.pending}
          className='cs-button mt2'>
          Confirm Availability and Expiry Dates
        </button>
      </div>
    )
  }
}

ExpiryDateTimePicker.propTypes = {
  sharedScreener: PropTypes.object,
  onSave: PropTypes.func
}

export default ExpiryDateTimePicker
